"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.map = void 0;
function map(_map, callback) {
    var res = [];
    _map.forEach(function (item, key, theMap) {
        res.push(callback(item, key, theMap));
    });
    return res;
}
exports.map = map;
//# sourceMappingURL=map.js.map